import * as Styled from '../../../components/Ratings/DisplayTag/DisplayTag.styled';
import React from 'react';
import {
  DisplayTagProps,
  Shades,
} from '../../../components/Ratings/DisplayTag/DisplayTag.typed';

const DisplayTag = (props: DisplayTagProps) => {
  const { shade = 'WHITE', children, className, ...rest } = props;
  const shades: Shades = {
    WHITE: {
      backgroundColor: 'WHITE',
      borderColor: 'GREY',
      textColor: 'GREY_DARKER',
    },
    GREEN: {
      backgroundColor: 'GREEN_LIGHTER',
      borderColor: 'GREEN_LIGHTER',
      textColor: 'GREEN_DARKER',
    },
    GREY: {
      backgroundColor: 'GREY_LIGHT',
      borderColor: 'GREY_LIGHT',
      textColor: 'GREY_DARKER',
    },
  };

  return (
    <Styled.DisplayTag {...shades[shade]} className={className} {...rest}>
      {children}
    </Styled.DisplayTag>
  );
};

export { DisplayTag };
